import { render } from "./SurgeryMedicineModal.vue?vue&type=template&id=567237b8&scoped=true"
import script from "./SurgeryMedicineModal.vue?vue&type=script&lang=js"
export * from "./SurgeryMedicineModal.vue?vue&type=script&lang=js"

import "./SurgeryMedicineModal.vue?vue&type=style&index=0&id=567237b8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-567237b8"]])

export default __exports__